import { GetterTree } from 'vuex'
import * as types from './types';

export default <GetterTree<mail.state.MailState, RootState>>{
    [types.EMAIL_CURRENT](state: mail.state.MailState) {
        return state.currentEmail;
    },

    [types.EMAIL_SELECT](state: mail.state.MailState) {
        return state.selections;
    },

    [types.FOLDER_LIST](state) {
        return state.folders.items;
    },
}
